import { render, staticRenderFns } from "./moaUpdate.vue?vue&type=template&id=2dcfd4e4&"
import script from "./moaUpdate.vue?vue&type=script&lang=js&"
export * from "./moaUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports